"use client";

import { FlexRow } from "@/components/flex-row";
import { Button } from "@/components/ui/button";

const uiText = {
  next: "Suivant",
  previous: "Précédant",
};

function StepNavigation({
  isNextDisabled,
  isPreviousDisabled,
  nextLabel = uiText.next,
  onNext,
  onPrevious,
  previousLabel = uiText.previous,
  showNext = true,
  showPrevious = true,
}: {
  isNextDisabled?: boolean;
  isPreviousDisabled?: boolean;
  nextLabel?: string;
  onNext: () => void;
  onPrevious: () => void;
  previousLabel?: string;
  showNext?: boolean;
  showPrevious?: boolean;
}) {
  return (
    <FlexRow className="w-full py-4">
      {showPrevious ? (
        <Button
          disabled={isPreviousDisabled}
          onClick={onPrevious}
          type="button"
          variant="outline"
        >
          {previousLabel}
        </Button>
      ) : (
        <span />
      )}

      {showNext ? (
        <Button disabled={isNextDisabled} onClick={onNext} type="button">
          {nextLabel}
        </Button>
      ) : null}
    </FlexRow>
  );
}

export { StepNavigation };
